const backofficeLoginRouter = {
  path: 'login',
  name: 'backoffice-login',
  component: () => import('../views/LoginView.vue'),
  meta: {
    requiresAuth: false
  }
}

export { backofficeLoginRouter }
